module.exports = __webpack_public_path__ + "static/media/hearingLoss.242f7888.svg";